export default __webpack_public_path__ + "static/media/2.1aacbf76.svg";